import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { fade } from '@material-ui/core/styles/colorManipulator';
import {withStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
import orange from "@material-ui/core/colors/orange";
import blue from "@material-ui/core/colors/blue";
import {getSchedule} from "../../requests";

const selectTheme = createMuiTheme({
    palette: {
        primary: blue,
        secondary: orange
    }
});
const styles = theme => ({
    root: {
        width: '100%',
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    title: {
        display: 'none',
        color: '#fff',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 220,
        color: '#fff',
    },
});

function Header(props) {
    const { classes, organizationsList, organizationCode, organizationSwitcher, tSesSwitcher } = props;
    let organization,
        organizationShortName;

    for (let i = 0; i < organizationsList.length; i++) {
        if (organizationsList[i].organizationCode === organizationCode) {
            organization = organizationsList[i].organization;
            organizationShortName = organizationsList[i].organizationShortName
        }
    }

    const handleOrganizationChange = event => {
        for (let i = 0; i < organizationsList.length; i++) {
            if (organizationsList[i].organizationCode === event.target.value) {
                organization = organizationsList[i].organization;
                organizationShortName = organizationsList[i].organizationShortName
            }
        }
        props.setOrganization({
            organizationCode: event.target.value,
            organization: organization,
            organizationShortName: organizationShortName
        });

        props.setSchedule({ schedule: [], loading: true, organization: organization, organizationShortName: organizationShortName });
        props.setTSesList([]);

        getSchedule({
            organization: event.target.value,
            deep: props.days,
            setSchedule: props.setSchedule,
            setTSesList: props.setTSesList,
            setOrganizationList: props.setOrganizationList})
    };

    const handleDeepChange = event => {
        props.setScheduleDeep(event.target.value);

        props.setSchedule({ schedule: [], loading: true, organization: organization, organizationShortName: organizationShortName });

        getSchedule({
            organization: !!organizationCode ? organizationCode : '240013',
            deep: event.target.value,
            setSchedule: props.setSchedule,
            setTSesList: props.setTSesList,
            setOrganizationList: props.setOrganizationList})
    };

    const handleTSesChange = event => {
        props.setSchedule({ schedule: [], loading: true, organization: organization, organizationShortName: organizationShortName });
        props.setTSes(event.target.value);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" style={{backgroundColor: '#2196f3'}}>
                <Toolbar
                    style={{
                        width: '90%',
                        margin: 'auto',
                    }}
                >
                    <Typography className={classes.title} variant="h6" color="inherit" noWrap>
                        Мониторинг расписания
                    </Typography>
                    <div className={classes.grow} />
                    <MuiThemeProvider theme={selectTheme}>
                        {organizationSwitcher  ?
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="age-simple" style={{color: '#fff'}}>Организация</InputLabel>
                                <Select
                                    value={props.organizationCode}
                                    onChange={handleOrganizationChange}
                                    inputProps={{
                                        name: 'organization',
                                        id: 'organization',
                                    }}
                                    style={{color: '#fff'}}
                                >
                                    {props.organizationsList.map(organization => (
                                        <MenuItem value={organization.organizationCode}>{organization.organizationShortName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        : null}
                        {tSesSwitcher  ?
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="age-simple" style={{color: '#fff'}}>Тип записи</InputLabel>
                                <Select
                                    value={props.tSes}
                                    onChange={handleTSesChange}
                                    inputProps={{
                                        name: 'tses',
                                        id: 'tses',
                                    }}
                                    style={{color: '#fff'}}
                                >
                                    {props.tSesList.map(tSes => (
                                        <MenuItem value={tSes.pers}>{tSes.title}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        : null}
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="age-simple" style={{color: '#fff'}}>Интервал</InputLabel>
                            <Select
                                value={props.days}
                                onChange={handleDeepChange}
                                inputProps={{
                                    name: 'deep',
                                    id: 'deep',
                                }}
                                style={{color: '#fff'}}
                            >
                                <MenuItem value={14}>2 недели</MenuItem>
                                <MenuItem value={21}>3 недели</MenuItem>
                                <MenuItem value={28}>4 недели</MenuItem>
                                <MenuItem value={56}>5-8 недель</MenuItem>
                            </Select>
                        </FormControl>
                    </MuiThemeProvider>
                </Toolbar>
            </AppBar>
        </div>
    )
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);